<li><a routerLink="/welcome-board" title="Home">Home Page</a></li>
<li *ngIf="fascicolo"><a
	[routerLink]="['/pratica', tipoPratica, getPraticaViewPath(), pratica.id]"
	title="Vai alla pratica">
		{{pratica.intestazione.campi.posizionePratica}}</a></li>
<li>{{ fascicolo? fascicolo.intestazione.campi.posizione: pratica.intestazione.campi.posizionePratica }}</li>